function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeetingConfirmed = function SvgMeetingConfirmed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.932,
    height: 25.932,
    viewBox: "0 0 6.861 6.861"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64.527 -145.07)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.958,
    cy: 148.5,
    r: 3.431,
    style: {
      fill: "#a4c460",
      fillOpacity: 1,
      strokeWidth: 0.122567,
      strokeOpacity: 0.517677
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4Z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.1884 0 0 .1884 65.707 146.231)"
  })));
};
export default SvgMeetingConfirmed;